/* istanbul ignore next */
const ACTIONS = {
    TOGGLE_HELP_MODAL: 'TOGGLE_HELP_MODAL',
    HANDLE_ONCHANGE: 'HANDLE_ONCHANGE',
    HANDLE_ONBLUR: 'HANDLE_ONBLUR',
    SUBMIT_HELP_FORM: 'SUBMIT_HELP_FORM',
    SUBMIT_HELP_FORM_ERROR: 'SUBMIT_HELP_FORM_ERROR',
    SUBMIT_HELP_FORM_SUCCESS: 'SUBMIT_HELP_FORM_SUCCESS',
    SHOW_FIELD_ERROR: 'SHOW_FIELD_ERROR',
    PREPOPULATE_INELIGIBLE_VALUES: 'PREPOPULATE_INELIGIBLE_VALUES'
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    toggleHelpModal(fieldVal, modalType, unlistedSoftware) {
        return {
            type: ACTIONS.TOGGLE_HELP_MODAL,
            payload: {
                fieldVal,
                modalType,
                unlistedSoftware,
            }
        };
    },

    handleFieldValOnChange(id, value) {
        return {
            type: ACTIONS.HANDLE_ONCHANGE,
            payload: {
                id,
                value
            }
        };
    },

    handleFieldValOnBlur(id, value) {
        return {
            type: ACTIONS.HANDLE_ONBLUR,
            payload: {
                id,
                value
            }
        };
    },

    submitHelpForm(helpFormData) {
        return {
            type: ACTIONS.SUBMIT_HELP_FORM,
            payload: {
                helpFormData
            }
        };
    },

    alertSuccess(msgKey) {
        return {
            type: ACTIONS.SUBMIT_HELP_FORM_SUCCESS,
            payload: {
                msgKey
            }
        };
    },

    alertError(errorKey) {
        return {
            type: ACTIONS.SUBMIT_HELP_FORM_ERROR,
            payload: {
                errorKey
            }
        };
    },

    showFieldError() {
        return {
            type: ACTIONS.SHOW_FIELD_ERROR
        };
    },

    prepopulateIneligibleValues(preState) {
        return {
            type: ACTIONS.PREPOPULATE_INELIGIBLE_VALUES,
            payload: {
                preState
            }
        };
    }
};

export default {
    ...ACTIONS,
    ...ACTION_CREATORS
};
